import React, { useState } from 'react'

const DrillThruGlobalSearch = (props: { vuid: number, handle_GlobalSearch: (value: string) => void }) => {
    //FP-11288 - Global search front-end changes
    const [globalSearchText, setGlobalSearchText] = useState<string>("")
    return (
        <div className="w-100">
            <div id='drill_thru_vu_search' className='d-flex justify-content-end align-items-center mt-2 gap-2'>
                <div className="search-container"
                    style={{ width: "20%" }}
                >
                    <span className="deleteicon">
                        <input
                            value={globalSearchText}
                            style={{ boxShadow: 'none' }}
                            onChange={(e) => setGlobalSearchText(e.target.value)}
                            id={`dt_search_${props.vuid}`}
                            className='form-input pe-4' // pe-4 = padding-end to make room for the icon
                            type='text'
                            maxLength={45}
                            placeholder='Search'
                        />
                        <span onClick={() => setGlobalSearchText("")} style={{ right: '20px', top: '8px' }} className="clear_search_cross"></span>
                    </span>
                </div>

                {/* Button */}
                <button onClick={() => props.handle_GlobalSearch(globalSearchText)} className='app-button'>
                    <span className='ui-button-text' style={{ whiteSpace: 'nowrap' }}>
                        Global Search
                    </span>
                </button>
            </div>
        </div>
    )
}

export default DrillThruGlobalSearch